import { CarrierxAPI } from '@/services/api'

export default {
    fetchCountries() {
        return CarrierxAPI.get(`countries`, {params: {include_fields: 'common_name', order: 'common_name asc'}})
            .then(response => response.data)
    },
}